module.exports = __webpack_public_path__ + "img/Logo_Header.4a201a20.png";